class RequestError {
    static create(params) {
        return new RequestError(params);
    }

    constructor({type, message}) {
        this.type = type;
        this.message = message;
    }

    getMessage() {
        return this.message;
    }

    getType() {
        return this.type;
    }

    hasType(type) {
        return this.getType() === type;
    }

    isAuthentication() {
        return this.hasType('Authentication');
    }

    isInactiveRegistration() {
        return this.hasType('InstitutionRegistrationInactive');
    }

    isUnauthorizedLocation() {
        return this.hasType('UnauthorizedLocation');
    }
}

export default RequestError;